import { db } from "../services/firebase";
import { collection, doc, getDoc, setDoc, updateDoc, writeBatch, query, where, getDocs } from "firebase/firestore";

export async function getSISSettings(campus) {
  const id = String(campus || "global").toLowerCase();
  const ref = doc(db, "sis_settings", `sy_${id}`);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}

export async function setSISSettings(campus, patch) {
  const id = String(campus || "global").toLowerCase();
  const ref = doc(db, "sis_settings", `sy_${id}`);
  await setDoc(ref, { campus: id, ...(patch || {}), updatedAt: new Date().toISOString() }, { merge: true });
  return true;
}

export async function getActiveSchoolYear(campus) {
  const s = await getSISSettings(campus);
  return s?.schoolYear || null;
}

export async function setActiveSchoolYear(campus, schoolYear) {
  return setSISSettings(campus, { schoolYear });
}

function nextGrade(grade) {
  const g = String(grade || "").trim();
  const map = {
    "nursery": "Kinder",
    "kinder": "Grade 1",
    "grade 1": "Grade 2",
    "grade 2": "Grade 3",
    "grade 3": "Grade 4",
    "grade 4": "Grade 5",
    "grade 5": "Grade 6",
    "grade 6": "Grade 7",
    "grade 7": "Grade 8",
    "grade 8": "Grade 9",
    "grade 9": "Grade 10",
    "grade 10": "Grade 11",
    "grade 11": "Grade 12",
    "grade 12": "Grade 12"
  };
  const key = g.toLowerCase();
  return map[key] || g;
}

export async function promoteStudents(campus, fromSY, toSY, options = {}) {
  const keepSection = Boolean(options.keepSection);
  const id = String(campus || "").toLowerCase();
  const q = query(collection(db, "students"), where("campus", "==", id));
  const snap = await getDocs(q);
  let batch = writeBatch(db);
  let count = 0;
  for (const d of snap.docs) {
    const s = d.data();
    const history = Array.isArray(s.history) ? s.history : [];
    const updated = {
      gradeLevel: nextGrade(s.gradeLevel || ""),
      section: keepSection ? (s.section || "") : "",
      enrollmentYear: Number(String(toSY).split("-")[0]) || new Date().getFullYear(),
      history: history.concat([{
        at: new Date().toISOString(),
        type: "promote",
        fromSchoolYear: fromSY,
        toSchoolYear: toSY,
        fromGrade: s.gradeLevel || "",
        toGrade: nextGrade(s.gradeLevel || "")
      }])
    };
    batch.update(d.ref, updated);
    count += 1;
    if (count % 400 === 0) {
      await batch.commit();
      batch = writeBatch(db);
    }
  }
  await batch.commit();
  await setActiveSchoolYear(campus, toSY);
  return count;
}

export async function recordStudentStatus(studentId, payload) {
  const ref = doc(db, "students", String(studentId));
  const snap = await getDoc(ref);
  if (!snap.exists()) return false;
  const s = snap.data();
  const history = Array.isArray(s.history) ? s.history : [];
  const entry = {
    at: new Date().toISOString(),
    type: payload.type,
    note: payload.note || "",
    effectiveDate: payload.effectiveDate || new Date().toISOString().slice(0,10),
    toCampus: payload.toCampus || ""
  };
  const updates = {
    status: payload.type === "withdraw" ? "withdrawn" : (payload.type === "transfer" ? "transferred" : (payload.type === "return" ? "active" : (s.status || "active"))),
    history: history.concat([entry])
  };
  await updateDoc(ref, updates);
  return true;
}
